module.exports = __webpack_public_path__ + "img/text-bar.9c4dbdca.png";